import React from 'react';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import PosterRegistrationForm from '../components/Auth/PosterRegistrationForm';
import { Typography, Box } from '@mui/material';

function PosterRegister() {
  return (
    <div className="register">
      <div className="register__container">
        <div className="register__logo">
          <HomeIcon style={{ fontSize: 50, color: '#1DA1F2' }} />
        </div>
        <Typography variant="h4" component="h1" gutterBottom>
          投稿ユーザー登録
        </Typography>
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1">
            投稿ユーザー向けの情報登録ページです。店舗情報とプロフィール情報を入力してください。
          </Typography>
        </Box>
        
        <PosterRegistrationForm />
        
        <div className="register__footer">
          <p>
            既にアカウントをお持ちですか？{' '}
            <Link to="/login">ログインする</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default PosterRegister; 